import {
  //naturalperson_patient_create,
  naturalperson_patient_list,
  naturalperson_patient_create,
  naturalperson_patient_update,
  naturalperson_persons_list,
  naturalperson_patient_main_read,
  naturalperson_patient_addresses_list,
  naturalperson_patient_addresses_create,
  naturalperson_patient_addresses_read,
  naturalperson_patient_addresses_update,
  naturalperson_patient_addresses_delete,
  naturalperson_patient_addresses_main_read,
  naturalperson_patient_addresses_main_update,
  naturalperson_patient_read,
  naturalperson_doctor_list,
  naturalperson_doctor_read,
  naturalperson_doctor_update,
  naturalperson_doctor_create,
  contact_site_create,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";

import Vue from "vue";

export default {
  namespaced: true,
  state: {
    profiles: {
      pharmacist: {
        uuid: null,
      },
      insuranceworker: {
        uuid: null,
      },
    },
    // Lista de personas del usuario
    patients: [],
    // Lista de doctores del usuario
    doctors: [],
    // Paciente seleccionado
    patientSelected: undefined,
    patient_addresses: undefined,
    mainpatient: undefined,
  },
  actions: {
    SELECT_PATIENT: ({ commit }, payload) => {
      return commit("SELECT_PATIENT", payload);
    },
    REQUEST_PERSON: (_, payload) => {
      return new Promise((resolve, reject) => {
        var data = {
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        };
        if (payload.pt_uuid) {
          data["patient"] = payload.pt_uuid;
        }
        naturalperson_persons_list(data).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_PATIENT: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_DOCTOR: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_doctor_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          dtUuid: payload.doctor_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_MAIN_PATIENT: ({ commit, rootGetters }) => {
      if (rootGetters["auth/isAuthenticated"]) {
        return new Promise((resolve, reject) => {
          naturalperson_patient_main_read({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
          }).then(
            response => {
              commit("MUTATE_MAIN_PATIENT", response.data);
              resolve(response);
            },
            err => {
              reject(err);
            }
          );
        });
      }
    },
    REQUEST_DOCTOR: ({ commit }) => {
      return new Promise((resolve, reject) => {
        naturalperson_doctor_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            commit("MUTATE_DOCTORS", response.data.results);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    NEW_DOCTOR: ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_doctor_create({
          data: payload.data,
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            dispatch("naturalperson/REQUEST_DOCTOR", {}, { root: true });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    PATCH_DOCTOR: ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_doctor_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          dtUuid: payload.doctor_uuid,
          data: payload.data,
        }).then(
          response => {
            dispatch("naturalperson/REQUEST_DOCTOR", {}, { root: true });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PATIENT: ({ commit }) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            commit("MUTATE_PATIENTS", response.data.results);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    PATCH_PATIENT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
          data: payload.data,
        }).then(
          response => {
            commit("UPDATE_PATIENT", response.data);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    NEW_PATIENT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_create({
          data: payload.data,
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            commit("ADD_PATIENT", response.data);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_ADDRESSES: ({ commit }, payload) => {
      const offset = payload.per_page * (payload.current_page - 1);
      var data_send = {
        $config: axconf(),
        role: "vooyguest",
        roleUuid: "1",
        ptUuid: payload.pt_uuid,
        limit: payload.per_page,
      };
      if (!isNaN(offset)) {
        data_send.push({
          offset: offset,
        });
      }
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_list(data_send).then(
          response => {
            // TODO: Cuidado con esto, no estamos gestionando la paginación
            commit("MUTATE_ADDRESSES", {
              patient_uuid: payload.pt_uuid,
              addresses: response.data.results,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_MAIN_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_main_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
          aUuid: payload.a_uuid,
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    DELETE_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_delete({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          ptUuid: payload.pt_uuid,
          aUuid: payload.a_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    PATCH_MAIN_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_main_update({
          $config: axconf(),
          ptUuid: payload.pt_uuid,
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    PATCH_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_update({
          $config: axconf(),
          aUuid: payload.a_uuid,
          ptUuid: payload.pt_uuid,
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    NEW_ADDRESS: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        naturalperson_patient_addresses_create({
          data: payload.data,
          ptUuid: payload.pt_uuid,
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    DELETE_PATIENTS: ({ commit }) => {
      commit("MUTATE_PATIENTS", []);
      commit("DELETE_PATIENT");
    },
    SEND_CONTACT_FORM: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        contact_site_create({
          $config: axconf(),
          /*
            Todas las apps comparten la misma API, asi que necesitamos pasar un
            parametro adicional para poder diferenciar.
          */
          site: "vooymarket",
          /* -- */
          role: "vooyguest",
          roleUuid: "1",
          data: payload,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    MUTATE_ADDRESSES: (state, payload) => {
      var patient_addresses = state.patient_addresses;
      if (!patient_addresses) {
        patient_addresses = {};
        patient_addresses[payload.patient_uuid] = payload.addresses;
        Vue.set(state, "patient_addresses", patient_addresses);
        return;
      }
      var new_addresses = {};
      new_addresses[payload.patient_uuid] = payload.addresses;
      state.patient_addresses = Object.assign(
        state.patient_addresses,
        new_addresses
      );
    },
    MUTATE_MAIN_PATIENT: (state, patient) => {
      Vue.set(state, "mainpatient", patient);
      Vue.set(state, "patientSelected", patient);
    },
    MUTATE_DOCTORS: (state, doctors) => {
      Vue.set(state, "doctors", doctors);
    },
    MUTATE_PATIENTS: (state, patients) => {
      Vue.set(state, "patients", patients);
    },
    SELECT_PATIENT: (state, patient) => {
      Vue.set(state, "patientSelected", patient);
    },
    DELETE_PATIENT: state => {
      Vue.set(state, "patientSelected", null);
    },
    UPDATE_PATIENT: (state, patient) => {
      var i;
      for (i = 0; i < state.patients.length; ++i) {
        if (state.patients[i].uuid == patient.uuid) {
          state.patients[i] = patient;
        }
      }
      if (!state.patientSelected) {
        Vue.set(state, "patientSelected", patient);
        return;
      }
      state.patientSelected = Object.assign({}, patient);
    },
    ADD_PATIENT: (state, patient) => {
      state.patients.push(patient);
      if (!state.patientSelected) {
        Vue.set(state, "patientSelected", patient);
      }
    },
  },
  getters: {
    getMainPatient: state => {
      var patientMain =
        state.patients.filter(patient => {
          return patient.is_main === true;
        })[0] || undefined;
      if (!patientMain) {
        return state.patients[0];
      }
      return patientMain;
    },
    getAddressByCurrentPatient: state => {
      if (!state.patient_addresses) {
        return undefined;
      }
      if (!state.patientSelected) {
        return undefined;
      }
      return state.patient_addresses[state.patientSelected.uuid];
    },
    // Métodos para devolver el uuid del paciente seleccionado, nombre y uuid de la persona
    getUuidPatientSelected: state => {
      if (state.patientSelected) {
        return state.patientSelected.uuid;
      } else {
        return null;
      }
    },
    getNamePatientSelected: state => {
      if (state.patientSelected) {
        var firstname = state.patientSelected.firstname;
        if (!firstname) {
          firstname = "-";
        }
        var lastname = state.patientSelected.lastname;
        if (!lastname) {
          lastname = "";
        }
        return firstname + " " + lastname;
      } else {
        return null;
      }
    },
    getUuidPersonSelected: state => {
      if (!state.patientSelected) {
        return undefined;
      }
      return state.patientSelected.person;
    },
  },
};
